enum EAvailableFor {
  ALL = 'all',
  PHYSICAL = 'physical',
  JURIDICAL = 'juridical',
}

export default EAvailableFor;
